import React, {useEffect, useState} from 'react';
import {FormControl, FormControlLabel, RadioGroup} from '@mui/material';
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import {useDispatch, useSelector} from "react-redux";
import {
    getMarkedOperation,
    getOperationsObject,
    getSessionsFiltered,
    getWorklistOperations
} from '../../../store/reducers/booked_admissions';
import Button from "@mui/material/Button";
import APIForm from '../../../app/apiForm';
import {setSnackbar} from '../../../store/reducers/globals';
import Radio from '@mui/material/Radio';
import {admissionStatusTypes} from '../bookedAdmissions';
import {hasBAPermission, Permissions} from '../../../store/reducers/user';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import {useTranslation} from 'react-i18next';
import API from '../../../app/api';

export const useStyles = makeStyles((theme) => ({
    menu: {
        width: "25%",
        paddingRight: 10,
        borderRight: "1px solid grey"
    },
    content: {
        paddingLeft: 10,
        width: 300
        //width: "75%"
    },
    iframe: {
        width: "100%",
        height: "calc(100vh - 100px)"
    },
    iFrameSmaller: {
        width: "100%",
        height: "calc(100vh - 150px)"
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        color: "grey"
    },
    menuItemSelected: {
        borderRadius: 10,
        borderRight: "3px solid blue",
        display: "flex",
        alignItems: "center",
        color: "white",
        backgroundColor: theme.palette.background.paper
    },
    toolbarOnHeader: {
        position: "absolute",
        right: "62px",
        top: "6px"
    },
    textLabel: {
        marginTop: 10,
        marginBottom: 10,
        color: "#ACAFB3"
    },
    noSessionPrint: {
        color: "#c9362f",
        marginTop: 20
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#f2f2f2"
    }

}));

const PrintModal = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const sessionsAll = useSelector(getSessionsFiltered);
    const operations = useSelector(getOperationsObject);
    const markedOperation = useSelector(getMarkedOperation);
    const worklistOperations = useSelector(getWorklistOperations);

    const dialogOpenedFromWorklist = props?.admissionStatus === admissionStatusTypes?.WORKLIST
    const [view, setView] = React.useState(dialogOpenedFromWorklist ? "worklist" : props.onlyPatient ? 'surgery' : "surgeryList");
    const [url, setUrl] = React.useState(props.hasOwnProperty("setUrl") ? props.setUrl : null);
    const [landscape, setLandscape] = React.useState("Vertical");
    const [generating, setGenerating] = React.useState(false);
    const [sessionsType, setSessionsType] = React.useState("full");
    const [printedFormat, setPrintedFormat] = React.useState(props.hasOwnProperty("printedFormat") ? props.printedFormat : "");
    const [htmlBlob, setHtmlBlob] = React.useState(null);
    const [managePanel] = React.useState(props.hasOwnProperty("managePanelOn") ? props.managePanelOn : true);
    const [sessionObject, setSessionObject] = useState(null);

    useEffect(() => {
        let view = '';
        if(dialogOpenedFromWorklist) view = "worklist";
        else {
            if(!props.onlyPatient) view = "surgeryList";
            else {
                view = props.admissionType === "MDU"? "surgeryMDUPrint" : "surgeryPrint";
            }
        }
        setView(view);
    }, [dialogOpenedFromWorklist, props.onlyPatient, props.admissionType]);

    useEffect(() => {
        if(markedOperation?.bookedSession) {
            API.getSesionsByIds([markedOperation.bookedSession]).then(data => {
                let session = data?.__data?.[0];
                setSessionObject(session)

            }).catch(function (error) {
                // TODO: error handler !!!
                console.error(error);
            });
        }

    },[markedOperation])

    const handlePrint = (format = "pdf") => {
        let patientData = {};
        setGenerating(true);
        setPrintedFormat("");

        let sessionsToPrint = sessionsType !== "full" ? sessionsAll.filter((session) => {return session.timeOfDay.description === sessionsType}): sessionsAll;

        if(view === "surgeryList" || view === "worklist") {
            patientData = {
                name: view === "worklist"? "WORKLIST": sessionsAll[0].theatre.description,
                type: sessionsType !== "full" ? " ("+ sessionsType +")" : ''
            }
        } else {
            patientData = {
                name: markedOperation.patientName,
                nhs: markedOperation.patientId,
                hospital: markedOperation.patientId,
                dob: markedOperation.patientDob
            }
        }

        if(format === "pdf") {
            const tmpPrint = {
                __form: view,
                operation: {
                    ...markedOperation,
                    sessiosObj: sessionObject
                },
                ...patientData,
                list: sessionsToPrint,
                landscape: landscape === "Horizontal",
                operations: operations,
                worklist: worklistOperations
            };
            console.log("tmpPrint " + format, tmpPrint);
            APIForm.generatePdf("as", tmpPrint)
                .then(res => {
                    if (res) {
                        const blob = new Blob([res], {type: "application/pdf"});
                        let objectURL = URL.createObjectURL(blob);
                        setUrl(objectURL);
                        setGenerating(false);
                        setPrintedFormat(format);
                    }
                })
                .catch(err => {
                    dispatch(setSnackbar({type: "error", message: "The document could not be generated."}));
                });
        }
        if(format == "html") {
            APIForm.generateHtml("as", {
                    __form: view,
                    operation: {
                        ...markedOperation,
                        sessiosObj: sessionObject
                    },
                    ...patientData,
                    list: sessionsToPrint,
                    landscape: landscape === "Horizontal",
                    operations: operations,
                    worklist: worklistOperations
                })
                .then(res => {
                    if (res) {
                        const blob = new Blob([res], {type: "text/html"});
                        let objectURL = URL.createObjectURL(blob);
                        setUrl(objectURL);
                        setGenerating(false);
                        setPrintedFormat(format);
                        setHtmlBlob(blob);
                    }
                })
                .catch(err => {
                    dispatch(setSnackbar({type: "error", message: "The document could not be generated."}));
                });
        }
    }

    const copyHtmlToClipboard = () => {
        let blobHtml = null;
        if(props.setBlob != null){
            blobHtml = props.setBlob;
        } else {
            if(htmlBlob != null){
                blobHtml = htmlBlob;
            }
        }
        if(blobHtml != null){
            blobHtml.text().then((htmlText) => {
                let body = "To: \n" +
                    "Subject: Subject\n" +
                    "X-Unsent: 1\n" +
                    "Content-Type: text/html" + htmlText;

                var a = document.createElement('a');
                a.href = URL.createObjectURL(new Blob([body], {type: 'text/plain'}));
                a.download = "print.eml";
                a.style.visibility = "hidden";
                document.body.appendChild(a);
                a.click();
                // navigator.clipboard.writeText(htmlText).then(()=>{
                //     console.log("copied to clipboard");
                // })
            })
        } else {
            dispatch(setSnackbar({type: "error", message: "No data to generate email."}));
        }
    }


    const canPrint = dispatch(hasBAPermission(Permissions.BA_CAN_PRINT));

    const listCanGenerate = () => {
        let sessionsToPrint = (sessionsType !== "full" ? sessionsAll.filter((session) => {return session.timeOfDay.description === sessionsType}): sessionsAll);
        return view !== "surgeryList" || sessionsToPrint.length > 0

    }
    return(<>
            <div style={{display: "flex"}}>
                {managePanel &&
                <div className={classes.content}>
                    <div className={classes.textLabel}> What section to Print? </div>

                    <FormControl component="fieldset" className={classes.radioButton}>
                        <RadioGroup
                            name="socialCare"
                            value={view}
                            row
                            onChange={event => {
                                let value = event.target.value;
                                if (event.target.value === 'surgeryPrint' && props.admissionType === 'MDU') value = 'surgeryMDUPrint';
                                setView(value);
                            }}
                        >
                            <FormControlLabel value={props.admissionType === "MDU" ? "surgeryMDUPrint" : "surgeryPrint"}
                                              control={<Radio/>}
                                              disabled={!markedOperation || generating}
                                              label={t("Patient")}/>
                            {!props.onlyPatient && !dialogOpenedFromWorklist &&
                                <FormControlLabel value="surgeryList"
                                                  control={<Radio/>}
                                                  disabled={generating} label={t("List")}/>
                            }
                            {dialogOpenedFromWorklist &&
                                <FormControlLabel value="worklist"
                                                  control={<Radio/>}
                                                  disabled={generating} label={t("Worklist")}/>
                            }
                        </RadioGroup>
                    </FormControl>

                    <div className={classes.textLabel}> Orientation </div>

                    <FormControl component="fieldset" className={classes.radioButton}>
                        <RadioGroup
                            name="socialCare"
                            value={landscape}
                            row
                            onChange={event => {
                                setLandscape(event.target.value);
                            }}
                        >
                            <FormControlLabel value={"Vertical"} control={<Radio/>} disabled={generating} label={t("Vertical")}/>
                            <FormControlLabel value={"Horizontal"} control={<Radio/>} disabled={generating} label={t("Horizontal")}/>
                        </RadioGroup>
                    </FormControl>

                    {view === "surgeryList" && <div>
                        <div className={classes.textLabel}> Print Sessions </div>

                        <FormControl component="fieldset" className={classes.radioButton}>
                            <RadioGroup
                                name="socialCare"
                                value={sessionsType}
                                row
                                onChange={event => {
                                    setSessionsType(event.target.value);
                                }}
                            >
                                <FormControlLabel value={"full"} control={<Radio/>} disabled={generating} label={t("Full List")}/>
                                <FormControlLabel value={"PM"} control={<Radio/>} disabled={generating} label={t("PM Sessions")}/>
                                <FormControlLabel value={"AM"} control={<Radio/>} disabled={generating} label={t("AM Sessions")}/>
                                <FormControlLabel value={"Twighlight"} control={<Radio/>} disabled={generating} label={t("TW Sessions")}/>
                                <FormControlLabel value={"All Day"} control={<Radio/>} disabled={generating} label={t("All day Sessions")}/>

                            </RadioGroup>
                        </FormControl>
                    </div>}


                    {listCanGenerate() && <>
                        <div className={classes.textLabel}>File Type</div>
                        <div>
                            <Button disabled={generating || !canPrint} onClick={() => {
                                setUrl(null);
                                setGenerating(true);
                                setPrintedFormat("");
                                handlePrint("pdf")
                            }}>PDF</Button>
                            <Button disabled={generating || !canPrint} onClick={() => {
                                setUrl(null);
                                setGenerating(true);
                                setPrintedFormat("");
                                handlePrint("html")
                            }}>HTML</Button>
                        </div>
                    </>
                    }
                    {!listCanGenerate() && <div className={classes.noSessionPrint}> No Session to print </div>}
                    {printedFormat === "html" &&
                        <Button onClick={copyHtmlToClipboard}>{t("Download for mail")}</Button>
                    }
                </div>
                }

                <iframe className={managePanel ? classes.iframe : classes.iFrameSmaller} src={url} width="100%" height="600px"/>
                {printedFormat === "html" && !managePanel && (htmlBlob != null || props.setBlob != null) &&
                    <div className={classes.toolbarOnHeader}>
                        <IconButton className={classes.squareIcon} aria-label="sq" title={t("Download for mail")} onClick={() => copyHtmlToClipboard()}>
                            <DownloadIcon/>
                        </IconButton>
                    </div>
                }
            </div>
    </>
    );
};

export default PrintModal